import { RegexValidator } from './RegexValidator'

//eslint-disable-next-line
export const CODE_2FA_REGEX = /^\d{6}$/

export class Code2FAValidator extends RegexValidator {
    constructor() {
        super(CODE_2FA_REGEX, 'validations.code_2fa')
    }
}
